import React from 'react';
import { Link } from 'react-router-dom';

const LpFooter = () => {
  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center text-center">
        <img src="/assets/img/brand/logo-light.png" alt="Federal Trademark Experts" className="h-16 mb-10" />

        <p className="text-slate-400 text-sm mb-8">
          &copy; {new Date().getFullYear()} Federal Trademark Experts. All Rights Reserved.
        </p>

        <div className="flex items-center gap-6 text-sm text-slate-400">
          <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
        </div>
      </div>
    </footer>
  );
};

export default LpFooter;
